<div class="bg-secondary p-4 shadow-sm">
  <p class="text-center text-success fw-bold">¡Envío gratis en compras a partir de $2999!</p>
  <h3>Resumen de compra</h3>
  <hr/>
  <ul class="list-group">
  <li class="list-group-item d-flex justify-content-between align-items-center border-0">
  <strong>Subtotal: ({{ productCount }} productos)</strong>
  <span class="badge bg-order-details rounded-pill">{{ total | currency }}</span>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center border-0">
  Envío:
  <span *ngIf="total == 0" class="badge bg-order-details rounded-pill">{{ 0 | currency }}</span>
  <span *ngIf="total < 2999 && total > 0" class="badge bg-order-details rounded-pill">{{ envioActual | currency }}</span>
  <span *ngIf="total >= 2999" class="badge bg-order-details rounded-pill text-success"><strong>¡Envío gratis!</strong></span>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center border-0">
  Descuento:
  <span class="badge bg-order-details rounded-pill text-danger">-{{ descuentoAplicado | currency }}</span>
  </li>
  <li class="list-group-item d-flex justify-content-between align-items-center border-top border-0">
  <strong>Total de Orden:</strong>
  <span *ngIf="total == 0" class="badge bg-order-details rounded-pill">{{ 0 | currency }}</span>
  <span *ngIf="total != 0" class="badge bg-order-details rounded-pill">{{ granTotalActual | currency }}</span>
  </li>
  </ul>
  
  <div class="input-group mt-3">
  <input type="text"
  class="form-control"
  placeholder="Ingresa tu cupón"
  [(ngModel)]="cupon"
  (ngModelChange)="onCuponInputChange()"
  aria-label="Cupón de descuento">
  <button class="btn btn-outline-secondary" type="button" (click)="aplicarCupon()">Aplicar</button>
  </div>
  
  <!-- Mensaje de estado -->
  
  <div *ngIf="mensaje" class="mt-4 p-3 rounded-md text-sm font-medium"
  [ngClass]="{'bg-success text-white': tipoMensaje === 'success', 'bg-danger text-white': tipoMensaje === 'danger'}">
  {{ mensaje }}
  </div>
  
  </div>
  <button type="button" class="btn btn-bg d-block w-100 mt-3" (click)="proceedToPayment()">
  Pagar compra
  </button>
  <br>
  <button type="button" class="btn btn-danger d-block w-100 mt-3" (click)="regresar()" style="background-color: #ff4d4d; color: white; border: none; cursor: pointer; transition: background-color 0.3s ease;">
  Seguir comprando
  </button>

  <!-- Dialogo de cambios de precio/disponibilidad -->
  <div *ngIf="showPriceChangeDialog" style="position:fixed;inset:0;z-index:2000;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.5);">
    <div style="background:#fff;max-width:720px;width:94%;border-radius:8px;overflow:hidden;box-shadow:0 10px 30px rgba(0,0,0,0.3);">
      <div style="padding:16px 20px;border-bottom:1px solid #eee;display:flex;justify-content:space-between;align-items:center;">
        <div>
          <h5 style="margin:0">Se actualizará tu orden</h5>
          <div style="font-size:13px;color:#666">Se han detectado {{ changedItems.length }} producto(s) con cambios en precio o disponibilidad.</div>
        </div>
        <button (click)="showPriceChangeDialog=false" style="background:none;border:none;font-size:22px;line-height:1;cursor:pointer;padding:4px 8px;">×</button>
      </div>
      <div style="padding:14px 18px;max-height:56vh;overflow:auto;">
        <div style="background:#fff3cd;border:1px solid #ffeeba;padding:10px;border-radius:4px;margin-bottom:10px;color:#856404;">
          <strong>Atención:</strong> Al continuar, la orden será actualizada con los nuevos precios y cantidades. Si no estás de acuerdo, puedes revisar tu carrito primero.
        </div>

        <p style="margin:0 0 8px 0">Productos con cambios:</p>
        <ul style="list-style:none;padding:0;margin:0;">
          <li *ngFor="let it of changedItems" style="display:flex;gap:12px;padding:10px 0;border-bottom:1px solid #f4f4f4;align-items:center;">
            <img *ngIf="it.image" [src]="it.image" alt="img" style="width:60px;height:60px;object-fit:cover;border-radius:4px;" />
            <div style="flex:1;min-width:0;">
              <div style="font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ it.title }}</div>
              <div *ngIf="it.color">Color: {{ it.color }}</div>
              <div *ngIf="it.size">Talla: {{ it.size }}</div>
              <div *ngIf="it.type === 'removed'" style="color:#d9534f;margin-top:6px">Ya no está disponible.</div>
              <div *ngIf="it.type === 'changed'" style="margin-top:6px">Precio: {{ it.oldPrice | currency }} → {{ it.newPrice | currency }} · Cantidad: {{ it.oldQty }} → {{ it.newQty }}</div>
            </div>
          </li>
        </ul>
        <p style="margin-top:12px">Nuevo total estimado: <strong>{{ updatedGranTotal | currency }}</strong></p>
      </div>
      <div style="padding:12px 16px;border-top:1px solid #eee;display:flex;justify-content:flex-end;gap:8px;">
        <button type="button" class="btn btn-light" (click)="showPriceChangeDialog=false">Cancelar</button>
        <button type="button" class="btn btn-secondary" (click)="goToCartFromDialog()">Ver carrito</button>
        <button type="button" class="btn btn-primary" (click)="continueToPaymentFromDialog()">Actualizar y continuar al pago</button>
      </div>
    </div>
  </div>